<template>
  <div class="teaching-score-grade-input-range">
    <el-input-number :value="nextMaximum"
                     size="mini"
                     controls-position="right"
                     :precision="1"
                     disabled></el-input-number>
    <span class="letter">~</span>
    <el-input-number v-model.number="current.maximum"
                     :class="{'is-error': isError}"
                     size="mini"
                     controls-position="right"
                     :precision="1"
                     :step="1"
                     :min="getMin"
                     :max="getMax"
                     v-bind="$attrs"></el-input-number>
  </div>
</template>

<script>
export default {
  name: 'TeachingScoreGradeInputRange',
  props: {
    current: {
      type: Object,
      required: true
    },
    prev: Object,
    next: Object,
    maxScore: Number,
    minScore: Number
  },
  computed: {
    prevMaximum () {
      if (this.prev) {
        return this.prev.maximum
      } else {
        return this.maxScore
      }
    },
    nextMaximum () {
      if (this.next) {
        return this.next.maximum
      } else {
        return this.minScore
      }
    },
    getMin () {
      const nextMaximum = this.nextMaximum
      if (typeof nextMaximum === 'number') {
        return nextMaximum + 0.1
      }
    },
    getMax () {
      const prevMaximum = this.prevMaximum
      if (typeof prevMaximum === 'number') {
        if (this.current.includeMax) {
          return prevMaximum
        } else {
          return prevMaximum - 0.1
        }
      }
    },
    isError () {
      const getMin = this.getMin
      const getMax = this.getMax
      const getMaximum = this.current.maximum
      if (typeof getMin === 'number' && typeof getMax === 'number' && typeof getMaximum === 'number') {
        if (getMin > getMax || getMaximum < getMin || getMaximum > getMax) {
          return true
        }
      }
    }
  },
  watch: {
    isError: {
      handler (val) {
        this.$set(this.current, '$rangeError', val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-grade-input-range {
    display: flex;
    align-items: center;
    & > .letter {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
</style>
